<div class="mat-elevation-z8 marginTable">
  <div class="bodyTable">
    <mat-table #tableComponent [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container *ngFor="let dataColumn of columnData">
        <ng-container matColumnDef="{{dataColumn.columnValue}}">

          <ng-container *ngIf="!dataColumn.signatures; else existSignatures">
            <mat-header-cell *matHeaderCellDef>{{dataColumn.columnName}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element[dataColumn.columnValue]}}</mat-cell>
          </ng-container>
          
          <ng-template #existSignatures>
              <mat-header-cell *matHeaderCellDef>{{dataColumn.columnName}}</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <ng-container *ngIf="element.offerSignatures?.length > 0; else notOfferSig">
                    <ng-container *ngFor="let offerSignature of element.offerSignatures">
                      <div class="marginIcon buttonEdit" >
                        <ng-container [ngSwitch]="offerSignature.statusCode">
                          <mat-icon *ngSwitchCase="'SOL'" fontIcon="access_time" class="iconSignatureSol"></mat-icon>
                          <mat-icon *ngSwitchCase="'AUT'" fontIcon="check_circle" class="iconSignatureAut"></mat-icon>
                          <mat-icon *ngSwitchCase="'RECH'" fontIcon="cancel" class="iconSignatureRech"></mat-icon>
                          <mat-icon *ngSwitchCase="'REC'" fontIcon="how_to_reg" class="iconSignatureRec"></mat-icon>
                          <mat-icon *ngSwitchDefault fontIcon="help_outline" class="iconSignature"></mat-icon>
                        </ng-container>                        
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #notOfferSig>
                    Sin firmas registradas
                  </ng-template>
                </mat-cell>
          </ng-template>

        </ng-container>
      </ng-container>
      <ng-container matColumnDef="editar">
        <mat-header-cell *matHeaderCellDef>Editar</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="marginIcon buttonEdit" (click)=edit(element)>
            <mat-icon fontIcon="edit_note" class= "iconEdit"></mat-icon>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="eliminar">
        <mat-header-cell *matHeaderCellDef>Eliminar</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="marginIcon buttonEdit" (click)=delete(element)>
            <mat-icon fontIcon="delete_sweep" class= "iconEdit"></mat-icon>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="verDetalle">
        <mat-header-cell *matHeaderCellDef>Detalle</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="marginIcon buttonEdit" (click)=detail(element)>
            <mat-icon fontIcon="subject" class= "iconEdit"></mat-icon>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="columnName"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnName;"></mat-row>
    </mat-table>
  </div>
  <mat-paginator [length]="totalRecords"
    [pageSize]="tableModel.pageSize"
    [pageIndex]="(tableModel.pageNumber ?? 1) - 1"
    [pageSizeOptions]="pageOption"
    (page)="paginatorChange($event)">
  </mat-paginator>
</div>